'use strict';

var auteticacaoMdl = angular.module('autenticacaoMdl');
auteticacaoMdl.controller('autenticacaoCtrl', autenticacaoCtrl);

autenticacaoCtrl.$inject = ['$scope', '$state', 'Usuario', '$modal'];

function autenticacaoCtrl($scope, $state, Usuario, $modal) {

    $scope.usuario = {};
    $scope.anoAtual = new Date();

    //$scope.image = require('@/assets/img/autenticacao/fundo-default.jpg')

    var recuperacaoSenhaId;
    $scope.buscarTexto = function(){
        Usuario.recuperarSenha().then(function (response) {
            recuperacaoSenhaId = response.data.recuperacaoSenhaId;
            $scope.modal = $modal({
                scope: $scope,
                title: response.data.titulo,
                content: response.data.mensagem,
                show: true,
                html: true,      
                backdrop: false,
                template: require('./modal-recuperar-senha.html')               
            });
        }, function () {
        });
    }

    $scope.fecharModal = function () {        
        Usuario.recuperarSenhaContabilizar( recuperacaoSenhaId ).then(function (response) {
            $scope.modal.hide();
        }, function () {
        });
    }

    $scope.login = function (usuario) {
        
        Usuario.login(usuario).then(function () {

            Usuario.irPara('app.meus-chamados');

        }, function () {
            toastr.error("Você não possui permissão de acesso", 'Autenticação');
        });

    }

};


// WEBPACK FOOTER //
// ./src/modules/autenticacao/autenticacao-controller.js